import React from 'react';
import { Link } from 'react-router-dom';
import './preLogin.css';

/**
 * Componente principal para seleccionar el portal de acceso.
 * @component
 */
const PreLogin = () => {
  return (
    <div className="prelogin-wrapper">
      <Link to="/login" className="conductor-button">
        <i className="fas fa-user-tie"></i>
        <span className="conductor-button-text">Soy Conductor</span>
      </Link>

      <div className="prelogin-container">
        <div className="prelogin-header">
          <h1 className="prelogin-title">Bienvenido a 99 Envíos</h1>
        </div> 
        <div className="prelogin-options">
          <div className="prelogin-option">
            <h1 className="prelogin-option-title-top">Portal de Acceso</h1>
            <p className="prelogin-option-description">
              Conectamos tus envíos con el mejor servicio
            </p>
            <Link to="/login-top" className="prelogin-button prelogin-button-top">
              Ingresar a 99 Envíos
            </Link>
          </div>
        </div>
      </div>

      <div className="road"></div>
      <div className="truck-container">
        <svg width="140" height="70" viewBox="0 0 140 70">
          {/* Cabina */}
          <path d="M100,20 L120,20 L120,45 L100,45 Z" fill="#2c3e50"/>
          <path d="M105,25 L115,25 L115,35 L105,35 Z" fill="#ecf0f1"/>
          
          {/* Cuerpo principal */}
          <rect x="20" y="25" width="80" height="25" fill="#3498db"/>
          <rect x="20" y="22" width="80" height="3" fill="#2980b9"/>
          
          {/* Logo */}
          <text x="45" y="40" fill="#fff" fontSize="12" fontFamily="Arial">99</text>
          
          {/* Luces */}
          <circle cx="115" cy="42" r="2" fill="#f1c40f"/>
          
          {/* Ruedas con detalles */}
          <circle cx="35" cy="50" r="8" fill="#2c3e50"/>
          <circle cx="35" cy="50" r="4" fill="#7f8c8d"/>
          <circle cx="90" cy="50" r="8" fill="#2c3e50"/>
          <circle cx="90" cy="50" r="4" fill="#7f8c8d"/>
          
          {/* Detalles adicionales */}
          <rect x="20" y="35" width="80" height="2" fill="#2980b9" opacity="0.5"/>
        </svg>
      </div>
    </div>
  );
};

export default PreLogin;